import { useMemo } from 'react'
import { useQuery } from "@apollo/client"
import { PROFITSHARING_UNSUBSCRIBE } from "src/graphql/mutations/subscription"
import { investorAccountType } from "src/types/investor-account-types"
import { profitsharingUnsubscribeQuery } from "src/types/subscription-types"

const useQueryProfitSharingUnsubscribe = (investorAccount:investorAccountType | undefined | null) => {
  const {data : ProfitSharingRequest, ...query} = useQuery<profitsharingUnsubscribeQuery>(PROFITSHARING_UNSUBSCRIBE, {
		variables : {
			subscriptionID : investorAccount?.subscription?.subscriptionID,
		},
    skip : !investorAccount?.subscription?.subscriptionID
	})

  const profitSharingRequest = useMemo(() => {
		const prfShringReq = ProfitSharingRequest?.profitsharingUnsubscribe
		if(prfShringReq?.__typename === "ProfitsharingUnsubscribeOutput") return prfShringReq.profitSharing
    return undefined
	},[ProfitSharingRequest])

  const profitSharingRequestError = useMemo(()=>{
    const prfShringReq = ProfitSharingRequest?.profitsharingUnsubscribe
		if(prfShringReq?.__typename === "Error") return prfShringReq
    return undefined
  },[ProfitSharingRequest])

  return {
    data:profitSharingRequest,
    error:profitSharingRequestError,
    query,
  }
}

export default useQueryProfitSharingUnsubscribe